import { ReactElement } from 'react';
import { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserProfile } from 'shell/hooks/use-user-profile';

export const PrivateRoute = (): ReactElement => {
  const { userProfile } = useUserProfile();
  const isAuthenticated = useMemo(() => {
    return !!userProfile.datiLogin;
  }, [userProfile]);

  if (!isAuthenticated) {
    return <Navigate to="/autenticazione" />;
  }
  return <Outlet />;
};

PrivateRoute.displayName = 'Private Route Component';
